import React, { useState } from 'react';
import FullScreenModal from '@/components/Common/FullScreenModal/FullScreenModal';
import styles from './TermsOfServiceModal.module.scss';
import termsStyles from '@/pages/yanolja-coin/terms.module.scss';
import CallToActionButton from '@/components/Common/CallToActionButton/CallToActionButton';
import { preventAndThrottle } from '@/utils';
import CoinAccordion from '@/components/Coin/Accordion/CoinAccordion';
import CoinCheckableConsentTitle from '@/components/Coin/CheckableConsentTitle/CoinCheckableConsentTitle';
import { update } from 'ramda';
import usePolicyAPIQuery from '@/utils/hooks/react_query/policy-api/usePolicyAPIQuery';
import { TPolicyAPIType } from '@/models/PolicyAPI/interfaces/IPolicyAPIRequestParams';

export type AgreementsParams = {
  promotionType?: string;
  agreeRequire: boolean;
  agreeOptional?: boolean;
};

interface ITermsOfServiceModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onSubmit: (agreements: AgreementsParams) => void;
  title: string;
  promotionType?: string;
}

interface ITerm {
  path: TPolicyAPIType;
}

const Term: React.FC<ITerm> = ({ path }) => {
  const policyPrefix = 'pc/v1/policies/1/sub-templates/';
  const { data } = usePolicyAPIQuery({ query: { path: `${policyPrefix}${path}/html` } });
  return data ? (
    <div
      className={termsStyles.policy}
      style={{ overflow: 'auto', height: '100%' }}
      dangerouslySetInnerHTML={{ __html: data || '' }}
    />
  ) : null;
};

const TermsOfService0903Modal: React.VFC<ITermsOfServiceModalProps> = ({
  onRequestClose,
  isOpen,
  onSubmit,
  title,
  promotionType,
}) => {
  const [agreedToTerms, setAgreedToTerms] = useState([false]);
  // const required = agreedToTerms[0];

  return (
    <FullScreenModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={{
        content: title,
        left: 'close',
        onClickLeft: onRequestClose,
      }}
    >
      <section className={styles.container}>
        <CoinAccordion
          title={
            <CoinCheckableConsentTitle
              title="NOL 카드 개인정보 제3자 제공 동의"
              checked={agreedToTerms[0]}
              hideCheckBox
              setCallback={(checked) => setAgreedToTerms(update(0, checked))}
              id="agreed3"
            />
          }
          contents={<Term path={'privacy-req-third-party-nol-card'} key={2} />}
          headerClassName={styles.header}
          bodyClassName={styles.customAccordionBody}
          opened={false}
        />
      </section>
      <CallToActionButton
        type="fixed"
        onClick={preventAndThrottle(() => {
          onSubmit({
            promotionType,
            agreeRequire: true,
          });
        })}
      >
        확인
      </CallToActionButton>
    </FullScreenModal>
  );
};

export default TermsOfService0903Modal;
